import { SessionManager } from "sip.js/lib/platform/web";
import { Session } from "sip.js";

export class ExtendedSessionManager extends SessionManager {
  /**
   * Mute the audio track(s) for a given session
   */
  mute(session: Session) {
    const sdh = session.sessionDescriptionHandler as any;
    if (!sdh?.peerConnection) {
      return;
    }
  
    const pc: RTCPeerConnection = sdh.peerConnection;
    pc.getSenders().forEach((sender) => {
      if (sender.track && sender.track.kind === "audio") {
        sender.track.enabled = false;
      }
    });
  }
  

  /**
   * Unmute the audio track(s) for a given session
   */
  unmute(session: Session) {
    const sdh = session.sessionDescriptionHandler as any;
    if (!sdh?.peerConnection) {
      return;
    }
  
    const pc: RTCPeerConnection = sdh.peerConnection;
    pc.getSenders().forEach((sender) => {
      if (sender.track && sender.track.kind === "audio") {
        sender.track.enabled = true;
      }
    });
  }
}
